'use client';

import { Box } from '@mui/material';
import { FC } from 'react';

import { SimpleModal } from '../../modals';
import { UtilizationDetailsTable } from './utilizationDetailsTable';

type UtilizationDetailsModalProps = {
	leasingCountAndRateId: number;
	facilityId: string;
	getUrlToSubscriptionPage: (...x: any) => string;
	onModalClose: () => void;
};

export const UtilizationDetailsModal: FC<UtilizationDetailsModalProps> = ({
	leasingCountAndRateId,
	facilityId,
	getUrlToSubscriptionPage,
	onModalClose,
}) => (
	<Box
		sx={{
			width: '1200px',
			height: '1200px',
		}}
	>
		<SimpleModal
			title='Active Parkers'
			titleStyle={{
				fontWeight: 'bold',
				textAlign: 'left',
			}}
			confirmButtonInTopRightOfHeader
			handleConfirm={onModalClose}
			confirmText='Close'
			content={
				<UtilizationDetailsTable
					leasingCountAndRateId={leasingCountAndRateId}
					facilityId={facilityId}
					getUrlToSubscriptionPage={getUrlToSubscriptionPage}
				/>
			}
			contentStyle={{
				display: 'flex',
				flexDirection: 'column',
				margin: 'auto',
				maxWidth: '95%',
			}}
		/>
	</Box>
);
